import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Papa from 'papaparse'
import * as API from '@/api'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    map: null,
    webCartLayer: null,
    watchHandle: null,
    settings: null,
    config: null,
    news: [],
    actions: [],
    avanzamentoFasi: [],
    actionLayers: [],
    faseActive: null,
    minimize: false,
    characterizationConfigurator: [],
    indicatorsConfigurator: [],
    loading: null,
    regioni: [],
    tipologie: null,
    fasi: null,
    pds: null,
    interventi: null,
    charts: null
  },
  mutations: {
    SET_SETTINGS: (state, layers) => {
      state.settings = layers
    },
    SET_CONFIG: (state, layers) => {
      state.config = layers
    },
    SET_FASE: (state, fase) => {
      state.faseActive = fase
    },
    SET_REGIONI: (state, regioni) => {
      state.regioni = regioni
    },
    SET_TIPOLOGIE: (state, tipologie) => {
      state.tipologie = tipologie
    },
    SET_INTERVENTI: (state, interventi) => {
      state.interventi = interventi
    },
    SET_FASI: (state, fasi) => {
      state.fasi = fasi
    },
    SET_PDS: (state, pds) => {
      state.pds = pds
    },
    SET_NEWS: (state, payload) => {
      state.news = payload
    },
    SET_CHARACTERIZATION_CONFIGURATOR: (state, layers) => {
      state.characterizationConfigurator = layers
    },
    SET_TOGGLE_CHARACTERIZATION: (state, payload) => {
      state.characterizationConfigurator = state.characterizationConfigurator.map(c => {
        c.item.map(d => {
          if (payload.remove) {
            d.hidden = true
          } else if (d.layer.OBJECTID === payload.layer.OBJECTID) {
            d.hidden = !d.hidden
          }
          return d
        })
        return c
      })
    },
    SET_INDICATORS_CONFIGURATOR: (state, layers) => {
      state.indicatorsConfigurator = layers
    },
    SET_LOADING: (state, value) => {
      state.loading = value
    },
    SET_MINIMIZE: (state) => {
      state.minimize = !state.minimize
    },
    SET_MAXIMIZE: (state) => {
      state.minimize = false
    },
    SET_ESRI_MAP: (state, map) => {
      state.map = map
    },
    SET_CART_LAYER: (state, webCartLayer) => {
      state.webCartLayer = webCartLayer
    },
    SET_ACTION_LAYERS: (state, actionLayers) => {
      state.actionLayers = actionLayers
    },
    ADD_ACTIONS (state, layers) {
      state.actions = layers
    },
    NO_ACTIONS (state) {
      const noserver = []
      const sanitize = { }
      sanitize.id = 1
      sanitize.idAzione = 'sp-01'
      sanitize.nome = 'Raccordi 380 kV SE S. Maria Capua Vetere in entra-esce all\'elettrodotto "Patria – S. Sofia"'
      sanitize.tipo = 'Tipo Azione'
      sanitize.fase = 'Autorizzazione'
      sanitize.idFase = 'sp-01-01'
      sanitize.intervento = 'Rete AT area Nord di Udine'
      sanitize.descrizione = 'La direttrice a 150 kV compresa tra la stazione di Valmontone e la CP Cinecittà è caratterizzata dalla presenza di numerose derivazioni rigide e vincoli di portata che non assicurano un adeguato livello di sicurezza per l’alimentazione dei carichi locali.'
      sanitize.pds = 'SPD'
      sanitize.idPds = 'spd-02'
      sanitize.area = 'Nome Area'
      sanitize.regioni = ['Piemonte', 'Veneto']
      noserver.push(sanitize)
      state.actions = noserver
    },
    ADD_ACTION (state, action) {
      // ℹ️ Rimuovo azioni in più regioni chiamando il primo valore dell'array
      state.action = action ? action[0] : state.actions[0]
    },
    REMOVE_ACTIONS (state) {
      state.actions = []
    },
    SET_AVANZAMENTOFASI: (state, avanzamentoFasi) => {
      state.avanzamentoFasi = {
        series: avanzamentoFasi.slice(1).map(i => {
          return {
            name: i[0],
            data: i.slice(1)
          }
        }),
        xAxis: avanzamentoFasi[0].filter(s => s !== 'Category')
      }
    },
    SET_CHARTS: (state, charts) => {
      state.charts = charts
    }
  },
  actions: {
    LOAD_SETTINGS: function ({ commit }) {
      return axios.get('static/settings.json').then((response) => {
        commit('SET_SETTINGS', response.data)
        return response
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_CONFIG: function ({ commit }) {
      return axios.get('static/config/index.json').then((response) => {
        commit('SET_CONFIG', response.data)
        return response.data
      }, (err) => {
        console.log(err)
      })
    },
    LOAD_NEWS: function ({ commit }) {
      return Papa.parse('static/news/news.csv', {
        download: true,
        header: true,
        complete (response) {
          commit('SET_NEWS', response.data)
        },
        error (errors) {
          console.log('error', errors)
        }
      })
    },
    LOAD_TIPOLOGIE: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        API.tipologie(payload).then((response) => {
          commit('SET_TIPOLOGIE', response)
          resolve(response)
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_INTERVENTI: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        API.interventi(payload).then((response) => {
          commit('SET_INTERVENTI', response)
          resolve(response)
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_FASI: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        API.fasi(payload.id, payload.config).then((response) => {
          commit('SET_FASI', response)
          resolve(response)
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_PDS: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        API.pds(payload).then((response) => {
          commit('SET_PDS', response)
          resolve(response)
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_CHARACTERIZATION_CONFIGURATOR: function ({ commit }, payload) {
      API.caratterizzazione(payload.id, payload.config).then((response) => {
        commit('SET_CHARACTERIZATION_CONFIGURATOR', response.caratterizzazione)
        return response
      }, (err) => {
        console.log(err)
        return axios.get('static/characterization-configurator.json').then((response) => {
          commit('SET_CHARACTERIZATION_CONFIGURATOR', response.data)
          return err
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_REGIONI: function ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        API.regioni(payload).then((response) => {
          commit('SET_REGIONI', response)
          resolve(response)
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_INDICATORS_CONFIGURATOR: function ({ commit }, payload) {
      API.indicatori(payload.idAzione, payload.fase, payload.config).then((response) => {
        commit('SET_INDICATORS_CONFIGURATOR', response)
        return response
      }, (err) => {
        console.log(err)
        return axios.get('static/indicators-configurator.json').then((response) => {
          commit('SET_INDICATORS_CONFIGURATOR', response.data)
          return response
        }, (err) => {
          console.log(err)
        })
      })
    },
    LOAD_ACTIONS: function ({ commit }, payload) {
      commit('SET_LOADING', false)
      return new Promise((resolve, reject) => {
        API.viste(payload.filters, payload.fase, payload.config).then((response) => {
          // console.log('payload :', payload)
          resolve(response)
          commit('ADD_ACTIONS', response)
          commit('SET_LOADING', true)
        }).catch(error => {
          console.log('🔥 ', 'ERRORE SERVER', error)
          commit('ADD_ACTIONS', error)
        })
      })
    },
    LOAD_AVANZAMENTO: function ({ commit }) {
      return Papa.parse('static/charts/avanzamento-fasi.csv', {
        download: true,
        header: false,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete (response) {
          commit('SET_AVANZAMENTOFASI', response.data)
        },
        error (errors) {
          console.log('error', errors)
        }
      })
    },
    LOAD_CHARTS: function ({ commit }) {
      return axios.get('static/charts/charts.json').then((response) => {
        commit('SET_CHARTS', response.data)
        return response
      }, (err) => {
        console.log(err)
      })
    },
    CANCEL_ACTIONS: function ({ commit }) {
      commit('REMOVE_ACTIONS')
    }
  },
  getters: {

    charts: state => state.charts,

    regioni: state => state.regioni,

    fasi: state => state.fasi,

    tipologie: state => state.tipologie,

    pds: state => state.pds,

    interventi: state => state.interventi,

    minimize: state => state.minimize,

    characterizationConfigurator: state => state.characterizationConfigurator,

    news: state => state.news.reverse().map((news, index) => {
      news.id = index
      return news
    }).filter(n => n.titolo),

    indicatorsConfigurator: state => state.indicatorsConfigurator.filter(i => i.categoria),

    loading: state => state.loading,

    settings: state => state.settings,

    config: state => state.config,

    avanzamentoFasi: state => state.avanzamentoFasi,

    actions: state => state.actions,

    actionLayers: state => state.actionLayers,

    interventions: state => state.actions.length ? state.actions.reduce((h, a) => Object.assign(h, { [a['TBL_Interventi.intervento']]: (h[a['TBL_Interventi.intervento']] || []).concat(a) }), {}) : [],

    action: state => action => state.actions.filter(a => a['Azioni.idAzione'] === action.id).filter(a => a['Azioni.fase'] === action.fase)[0],

    otherActions: state => action => state.actions.filter(a => a['TBL_Interventi.intervento'] === action['TBL_Interventi.intervento']).filter(a => a['Azioni.azione'] !== action['Azioni.azione'])
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js